import React, { useState, useEffect } from "react";
import { Input, Button } from "antd";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";

const UpdatePassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const storedEmail = secureLocalStorage.getItem("forgot_email");
        if (!storedEmail) {
            toast.error("Session expired. Please request OTP again.");
            navigate("/forgot-password");
            return;
        }
        setEmail(JSON.parse(storedEmail));
    }, [navigate]);

    const validatePassword = (password) => {
        const regex = /^(?=.*[A-Z])(?=.*\d).{8,}$/;
        return regex.test(password);
    };

    const handleSubmit = async () => {
        if (!email || !newPassword || !confirmPassword) {
            toast.error("All fields are required");
            return;
        }
        if (!validatePassword(newPassword)) {
            toast.error(
                "Password must be at least 8 characters, contain one uppercase letter and one number"
            );
            return;
        }
        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}api/forgot-password-update`,
                {
                    email,
                    new_password: newPassword,
                    new_password_confirmation: confirmPassword,
                },
                { headers: { "Content-Type": "application/json" } }
            );

            if (res.data.status === true) {
                toast.success(res?.data?.message);
                secureLocalStorage.removeItem("forgot_email");
                localStorage.removeItem('otpExpiry');
                navigate("/");
            } else {
                toast.error(res?.data?.message || "Failed to update password");
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error updating password");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-100 px-4">
            <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full">
                <h2 className="text-2xl font-bold mb-2 text-brandBlue text-center">
                    Update Password
                </h2>
                <p className="text-gray-600 mb-6 text-center">
                    Enter your new password to continue.
                </p>

                <div className="space-y-4">
                    <Input value={email} disabled />
                    <Input.Password
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <Input.Password
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </div>

                <Button
                    type="primary"
                    className="w-full mt-6 bg-brandBlue"
                    onClick={handleSubmit}
                    loading={loading}
                >
                    Update Password
                </Button>
            </div>
        </div>
    );
}

export default UpdatePassword